import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { Timer as TimerIcon } from 'lucide-react';
import { serverNow } from '@/store/game';

/** Обратный отсчёт до серверного дедлайна (с поправкой на расхождение часов). */
export function Timer({ endsAt, className }: { endsAt: number | null; className?: string }) {
  const [now, setNow] = useState(serverNow);
  useEffect(() => {
    if (endsAt === null) return;
    const id = setInterval(() => setNow(serverNow()), 250);
    return () => clearInterval(id);
  }, [endsAt]);
  if (endsAt === null) return null;
  const left = Math.max(0, Math.ceil((endsAt - now) / 1000));
  const mm = Math.floor(left / 60);
  const ss = String(left % 60).padStart(2, '0');
  return (
    <span
      className={clsx('font-mono tabular-nums', left <= 10 ? 'text-blood-400' : 'text-zinc-100', left <= 5 && 'animate-pulse', className)}
      aria-label={`Осталось ${left} секунд`}
    >
      {mm}:{ss}
    </span>
  );
}

/** Секундомер для ручного режима: сколько идёт текущая фаза / речь. */
export function Stopwatch({ since, className }: { since: number; className?: string }) {
  const [now, setNow] = useState(serverNow);
  useEffect(() => {
    const id = setInterval(() => setNow(serverNow()), 500);
    return () => clearInterval(id);
  }, []);
  const sec = Math.max(0, Math.floor((now - since) / 1000));
  return (
    <span className={clsx('inline-flex items-center gap-1.5 font-mono tabular-nums', className)} title="Ручной режим: фазы переключает ведущий">
      <TimerIcon className="h-[0.8em] w-[0.8em] opacity-60" aria-hidden />
      {Math.floor(sec / 60)}:{String(sec % 60).padStart(2, '0')}
    </span>
  );
}
